import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { PaymentCancelPageContent } from 'client/contents/PaymentCancelPageContent/PaymentCancelPageContent'

type TProps = {}

const PaymentCancelPage: FC<TProps> = ({}) => {
  return (
    <article className="bg-palette-black flex h-full w-full flex-col">
      <AppHead />
      <PaymentCancelPageContent />
    </article>
  )
}

// @ts-expect-error
PaymentCancelPage.layout = (page) => page

export default PaymentCancelPage
